import { ClientConfig } from '@/model/clientConfig';
import { Module } from 'vuex';

const clientConfig: Module<any, any> = {
  state: {
    language: 'it',
    config: {
      global: {
        logo: '',
        fontFamily: '',
        primaryColor: '',
        privacyUrl: '',
        generalConditionsUrl: '',
        faviconUrl: '',
        passwordPolicy: {
          noStartingSpacesRgx: '',
          noEndingSpacesRgx: '',
          lowerCaseRgx: '',
          upperCaseRgx: '',
          numberRgx: '',
          specialCharRgx: '',
          length: 8
        }
      },
      resetPassword: {
        en: {
          title: '',
          description: '',
          btnText: ''
        },
        it: {
          title: '',
          description: '',
          btnText: ''
        }
      },
      forgotPassword: {
        en: {
          title: '',
          description: '',
          btnText: ''
        },
        it: {
          title: '',
          description: '',
          btnText: ''
        }
      },
      registrationRequestPanel: {
        en: {
          title: '',
          btnText: ''
        },
        utils: {
          btnBackground: '',
          phoneNumberRequired: false,
          hideThirdConsent: false
        },
        it: {
          title: '',
          btnText: ''
        }
      },
      signUp: {
        en: {
          profilingTitle: '',
          title: '',
          marketingTitle: '',
          thirdTitle: ''
        },
        it: {
          profilingTitle: '',
          title: '',
          marketingTitle: '',
          thirdTitle: ''
        }
      },
      signIn: {
        en: {
          forgotPassword: '',
          labelSocialLogin: '',
          btnText: '',
          title: ''
        },
        utils: {
          showSocialLogin: true,
          showRegistrationPanel: true,
          showForgotPassword: true,
          showFacebookLogin: true,
          showAppleLogin: true,
          showGoogleLogin: true
        },
        it: {
          forgotPassword: '',
          labelSocialLogin: '',
          btnText: '',
          title: ''
        }
      }
    } as ClientConfig,
    isIframe: false,
    isLoading: false,
    configIsSet: false
  },
  mutations: {
    setConfig (state, payload: ClientConfig) {
      state.config = payload;
      state.configIsSet = true;
    },
    setLanguage (state, payload: string) {
      state.language = payload;
    },
    setIsIframe (state, isIframe) {
      state.isIframe = isIframe;
    },
    setIsLoading (state, isLoading) {
      state.isLoading = isLoading;
    }
  },
  actions: {
    setConfig ({ commit }, payload) {
      commit('setConfig', payload);
    },
    setLanguage ({ commit }, payload) {
      commit('setLanguage', payload);
    },
    setIsIframe ({ commit }, isIframe) {
      commit('setIsIframe', isIframe);
    },
    startLoading ({ commit }) {
      commit('setIsLoading', true);
    },
    endLoading ({ commit }) {
      commit('setIsLoading', false);
    }
  },
  getters: {
    language: ({ language }) => {
      return language;
    },
    isIframe: ({ isIframe }) => {
      return isIframe;
    },
    isLoading: ({ isLoading }) => {
      return isLoading;
    },
    global: ({ config }) => {
      return config.global;
    },
    signInMessages: ({ config, language }) => {
      return config.signIn[language.toLowerCase()];
    },
    signInUtils: ({ config }) => {
      return config.signIn.utils;
    },
    signUpMessages: ({ config, language }) => {
      return config.signUp[language.toLowerCase()];
    },
    forgotPasswordMessages: ({ config, language }) => {
      return config.forgotPassword[language.toLowerCase()];
    },
    resetPasswordMessages: ({ config, language }) => {
      return config.resetPassword[language.toLowerCase()];
    },
    registrationRequestPanelMessages: ({ config, language }) => {
      return config.registrationRequestPanel[language.toLowerCase()];
    },
    registrationRequestPanelUtils: ({ config }) => {
      return config.registrationRequestPanel.utils;
    },
    configIsSet: ({ configIsSet }) => {
      return configIsSet;
    },
    faviconUrl: ({ config }) => {
      return config.global.faviconUrl;
    },
    passwordPolicy: ({ config }) => {
      return {
        length: config.global.passwordPolicy?.length,
        noStartingSpacesRgx: new RegExp(config.global.passwordPolicy?.noStartingSpacesRgx),
        noEndingSpacesRgx: new RegExp(config.global.passwordPolicy?.noEndingSpacesRgx),
        lowerCaseRgx: new RegExp(config.global.passwordPolicy?.lowerCaseRgx),
        upperCaseRgx: new RegExp(config.global.passwordPolicy?.upperCaseRgx),
        numberRgx: new RegExp(config.global.passwordPolicy?.numberRgx),
        specialCharRgx: new RegExp(config.global.passwordPolicy?.specialCharRgx)
      };
    }
  }
};

export default clientConfig;
